export const formatPhoneNumber = value => {
  if (value) {
    const num = value.toString().replace(/\D/g, '');
    if (num.length > 6) {
      return (
        '(' +
        num.substring(0, 3) +
        ') ' +
        num.substring(3, 6) +
        '-' +
        num.substring(6, 10)
      );
    } else if (num.length > 3) {
      return '(' + num.substring(0, 3) + ') ' + num.substring(3, 6);
    } else {
      return num;
    }
  } else {
    return '';
  }
};

export const getCompletePropertyAddress = property => {
  if (property) {
    const streetNumber = property?.streetNumber ? property?.streetNumber : '';
    const streetName = property?.streetName ? property?.streetName : '';
    const aptNumber = property?.aptNumber ? property?.aptNumber : '';
    const city = property?.city ? property?.city : '';
    const state = property?.state ? property.state : '';
    const zipCode = property?.zipCode ? property?.zipCode : '';

    return [
      `${streetNumber} ${streetName} ${aptNumber}`.trim(),
      `${city}`.trim(),
      `${state} ${zipCode}`.trim(),
    ]
      .filter(Boolean)
      .join(', ');
  } else {
    return '';
  }
};

export const formatBooleanValue = (value?: boolean): string | null => {
  if (value == null) {
    return null;
  }
  return value ? 'Yes' : 'No';
}

export const formatStringDateTime = value => {
  const date = new Date(value);
  if (isNaN(date.getTime())) return '';
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat('en-US', options);
  return formatter.format(date).replace(',', '');
}
